'use strict';

module.exports = require('./helpers.core');
module.exports.easing = require('./helpers.easing');
module.exports.canvas = require('./helpers.canvas');
module.exports.options = require('./helpers.options');



/*****************
 ** WEBPACK FOOTER
 ** ./~/chart.js/src/helpers/index.js
 ** module id = 1230
 ** module chunks = 0
 **/